import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useUser();
  // Check user in context or localStorage
  const storedUser = localStorage.getItem("user");
  const isAuthenticated = user || storedUser;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
